import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import useDisplay from "../../../hooks/useDisplay";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgBody01 from "../../molecules/text/linSeedKr/Rg/lsRgBody01";
import { fileUrl } from "../../../api/api";
import moment from "moment";

function ReviewItemPage({ data }) {
  const contentRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);

  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const [isViewMore, setIsViewMore] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = isSmall ? 19.6 : 25.2; // 각 줄의 높이(px)
      const contentHeight = contentRef.current.offsetHeight;
      const lineCount = contentHeight / lineHeight;

      setIsShortContent(lineCount <= 4);
    }
  }, [data.content, isSmall]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          maxWidth: isMobile ? "100%" : isTablet ? "47.8%" : 585,
          minWidth: isMobile ? "100%" : isTablet ? "47.8%" : 585,
          position: "relative",
          background: "#F4FAFF",
          borderRadius: 15,
          padding: isMobile ? "30px" : "48px 40px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <img
            style={{
              width: isSmall ? 12 : 24,
              height: isSmall ? 12 : 24,
              marginRight: isSmall ? 4 : 8,
            }}
            src={"/assets/icons/star_3d.png"}
            alt="star_3d"
          />
          <LSBdDisplay02
            style={{
              color: "#101113",
              fontSize: isSmall ? 14 : 24,
              lineHeight: isSmall ? "19.6px" : "33.6px",
            }}
          >
            {data.score.toFixed(1)}
          </LSBdDisplay02>
        </div>

        <LSBdDisplay02
          style={{
            fontSize: isSmall ? 16 : 24,
            lineHeight: isSmall ? "22.4px" : "33.6px",
            color: "#101113",
            display: !isViewMore && "-webkit-box",
            WebkitBoxOrient: !isViewMore && "vertical",
            wordBreak: !isViewMore && "break-word",
            overflow: !isViewMore && "hidden",
            WebkitLineClamp: !isViewMore && 2, // 2줄부터 ... 표시
            marginBottom: 20,
          }}
        >
          {data.title}
        </LSBdDisplay02>

        <div
          ref={contentRef}
          $isSmall={isSmall}
          style={{
            color: "#101113",
            fontSize: isSmall ? 14 : 18,
            lineHeight: isSmall ? "19.6px" : "25.2px",
            display: !isViewMore && "-webkit-box",
            WebkitBoxOrient: !isViewMore && "vertical",
            wordBreak: !isViewMore && "break-word",
            overflow: !isViewMore && "hidden",
            WebkitLineClamp: !isViewMore && 4,
            marginBottom: isSmall ? "16px" : "32px",
          }}
        >
          {data.content}
        </div>

        {isViewMore || isShortContent ? (
          <div
            style={{
              height: 53,
            }}
          />
        ) : (
          <LSRgBody01
            onClick={() => {
              setIsViewMore(true);
            }}
            style={{
              height: 52,
              color: "#5050FF",
              textAlign: "right",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            더보기
          </LSRgBody01>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <img
            style={{
              width: isSmall ? 24 : 56,
              height: isSmall ? 24 : 56,
              marginRight: isSmall ? 8 : 24,
              borderRadius: 999,
            }}
            src={
              data.member.profileServerFileName
                ? `${fileUrl}/${data.member.profileServerFileName}`
                : "/assets/icons/profile.png"
            }
            alt="profile"
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <LSRgH2HeadLine
              style={{
                color: "#898E99",
                fontSize: isSmall ? 12 : 18,
                lineHeight: isSmall ? "14.4px" : "25.2px",
              }}
            >
              {data.member.nickname}
            </LSRgH2HeadLine>
            <LSRgBody01
              style={{
                color: "#898E99",
                marginTop: 5,
                fontSize: isSmall ? 10 : 14,
                lineHeight: isSmall ? "12px" : "19.6px",
              }}
            >
              {moment(data.createdAt).format("YYYY.MM.DD")}
            </LSRgBody01>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewItemPage;
